import Api from '@/services/Api'

export default {
  getList () {
    return Api().get('/invoices/')
  }
}
